/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Field, FieldArray, Form, Formik } from 'formik';
import Icon from 'components/Icon';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Layout, DateRangePicker, NotesModal } from 'components';
import { Col, Row } from 'components/Grid';
import Loader from 'components/Loader';
import { GridColumnTitle, InputField, Label, SelectField, } from 'components/Form';
import DialogComponent from "components/Dialog";
import { FitinsurAPI, MessageCenter } from 'utils';
import {
  FieldGrid,
  ColIcon,
  TableHeader,
  TableCollum,
  CalendarContainer,
  Content,
  ContentTextarea,
  CustomField,
  DialogCancel,
  DialogConfirm,
  InlineLabel,
  LoadContainer,
  FilterContainer,
  MobileLabel,
  RowFilterOrder,
  DialogIcon,
  TableHead,
  TableRow,
  TableBody,
  Table,
  RowFilterIcon,
  FilterSearchContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  Counter,
  FilterLabel,
  TooltipCard,
  TooltipText,
  TooltipBox,
} from './styles';
import { Button } from 'components/index';
import Checkbox from 'components/Form/CheckBox';
import Checkbox2 from 'components/Form/CheckBox2';
import HasPermission from 'components/HasPermission/index';
import MultiSelectField from 'components/Form/MultiSelectField';
import CacheManager from 'utils/src/cache-manager';

const columns = [
  {
    title: ''
  },
  {
    title: "DEAL",
    value: "deal",
    minWidth: 125
  },
  {
    title: "OFFICE",
    value: "office",
    minWidth: 60
  },
  {
    title: "CLIENT",
    value: "client",

  },
  {
    title: "DOC",
  },
  {
    title: "PARTY",
    value: "party",
  },
  {
    title: "AMOUNT",
    value: "amount",
    minWidth: 80
  },
  {
    title: "DUE DATE",
    value: "dueDate",
    minWidth: 80
  },
  {
    title: "IDENTIFIER",
  },
  {
    title: "INVOICE SENT",
    minWidth: 60
  },
  {
    title: "STATUS",
    minWidth: 80
  },
  {
    title: "ACTION",
    minWidth: 80,
    maxWidth: 80
  },
];

export default function PaymentPage(props) {
  const cache = new CacheManager();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const location = useLocation();
  const formik = useRef();
  const [sortBy, setSortBy] = useState(
    {
      key: null,
      direction: null,
    }
  );

  const [showCalendar, setShowCalendar] = useState(false);
  const [showInvoiceSentCalendar, setShowInvoiceSentCalendar] = useState(false);
  const [showPaymentNotesModal, setShowPaymentNotesModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [offices, setOffices] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [notesModalProps, setNotesModalProps] = useState(null);
  const [selectedPaymentsUpdate, setSelectedPaymentsUpdate] = useState([]);
  const [selectedPaymentsIndex, setSelectedPaymentsIndex] = useState([]);
  const [modalOptions, setModalOptions] = useState([]);
  const [dealGroup, setDealGroup] = useState(null);
  const [modal, setModal] = useState(false);
  const [filtersList, setFiltersList] = useState([]);
  const [isAbleEdit, setIsAbleEdit] = useState(false);
  const [isAbleDelete, setIsAbleDelete] = useState(false);
  const [isAbleCreate, setIsAbleCreate] = useState(false);
  const [typeDialog, setTypeDialog] = useState(null);
  const [filterOptions, setFilterOptions] = useState([]);
  const [tooltips, setTooltips] = useState([]);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    icon: "times-circle",
    args: null,
    type: ""
  });

  const region = authContext.region === 'en-GB' ? 'en' : 'en';

  const initialValues = {
    filter: {
      id: "",
      name: "",
      deal: "",
      office: "",
      client: "",
      doc: "",
      party: "",
      currency: "",
      dueDate: {
        from: null,
        to: null,
      },
      status: "",
      identifier: "",
      invoiceSent: {
        from: null,
        to: null,
      },
      hideAbortedTransactions: false,
      hideDirectPayment: false,
    },
    payments: data
  };
  const [currentReport, setCurrentReport] = useState(null);


  return (
    <>
      <Icon
        name="exportExcel"
        title="Export Documents"
        onClick={() => props.setShowExport(!props.showExport)}
      />

      <FilterContainer className={props.showExport ? 'filter-open close' : 'filter-close'}>
        <Row>
          <Col style={{ display: "flex", justifyContent: 'flex-start', marginBottom: 15 }}>
            <MobileLabel>Export Files</MobileLabel>
          </Col>
          <Col style={{ display: "flex", justifyContent: 'flex-end', marginBottom: 15 }}>
            <Icon name="close" className="icon-close" onClick={() => props.setShowExport(false)} />
          </Col>
        </Row>

        <HasPermission permission={props.permissions.PAYMENTS_EXPORT_PAYMENTS || props.permissions.PAYMENTS_IMPORT_OSND}>
          <RowFilter>
            <CheckBoxColumn>
              <Label>
                <Checkbox
                  name="Payments"
                  checked={currentReport === "payments"}
                  onChange={() => { setCurrentReport("payments") }}
                />
              </Label>
            </CheckBoxColumn>

            <FilterColumn>
              <FieldGrid
                name='i-Payments'
                placeholder='Payments'
                component={InputField}
                value={"Payments"}
                validation={false}
                type="text"
                readOnly
              />
            </FilterColumn>
          </RowFilter>

          <RowFilter>
            <CheckBoxColumn>
              <Label>
                <Checkbox
                  name="Bank Movements"
                  checked={currentReport === "bankMovements"}
                  onChange={() => { setCurrentReport("bankMovements") }}
                />
              </Label>
            </CheckBoxColumn>

            <FilterColumn>
              <FieldGrid
                name='i-Payments'
                placeholder='Bank Movements'
                component={InputField}
                value={"Bank Movements"}
                validation={false}
                type="text"
                readOnly
              />
            </FilterColumn>
          </RowFilter>
        </HasPermission>

        <HasPermission permission={props.permissions.PAYMENTS_EXPORT_REPORTS}>
          <RowFilter>
            <CheckBoxColumn>
              <Label>
                <Checkbox
                  name="Payments"
                  checked={currentReport === "projectReport1"}
                  onChange={() => { setCurrentReport("projectReport1") }}
                />
              </Label>
            </CheckBoxColumn>
            <FilterColumn>
              <FieldGrid
                name='i-projectReport1'
                placeholder='Project Report 1'
                component={InputField}
                value={"Project Report 1"}
                validation={false}
                type="text"
                readOnly
              />
            </FilterColumn>
          </RowFilter>
        </HasPermission>

        <HasPermission permission={props.permissions.PAYMENTS_EXPORT_REPORTS}>
          <RowFilter>
            <CheckBoxColumn>
              <Label>
                <Checkbox
                  name="Payments"
                  checked={currentReport === "projectReport2"}
                  onChange={() => { setCurrentReport("projectReport2") }}
                />
              </Label>
            </CheckBoxColumn>
            <FilterColumn>
              <FieldGrid
                name='i-projectReport2'
                placeholder='Project Report 2'
                component={InputField}
                value={"Project Report 2"}
                validation={false}
                type="text"
                readOnly
              />
            </FilterColumn>
          </RowFilter>
        </HasPermission>

        <Row align="center" className='apply-button-container'>
          <Col>
            <Button
              primary
              type="button"
              id="btnFilter"
              style={{ textAlign: "center", marginTop: 15 }}
              disabled={!currentReport}
              onClick={(e) => currentReport && props.onExportReport && props.onExportReport(currentReport)}
            >
              Export
            </Button>
          </Col>
        </Row>
      </FilterContainer>
    </>
  );
}
